import { getIcons } from "./components/Constant/Constant";

const listOfPropertyType = (function () {
  const propertyType = {
    LAYOUT: "propertyTypes/fOQZ4CPJQYZikZnFkrxy",
    RESALE_LAND: "propertyTypes/ZfO3nhrBLCS2aNhTcO5p",
    APARTMENT: "propertyTypes/xOl7nFLzvXtqVAcSrvIC",
    RESALE_BUILDING: "propertyTypes/sczwuE4dZNBGlJOfa3wd",
    VILLA: "propertyTypes/k6QfCzo0QVXutC3MUTfV",
  };
  return {
    get: function (type) {
      return propertyType[type];
    },
  };
})();

export const PropertyTypeList = [
  {
    id: "fOQZ4CPJQYZikZnFkrxy",
    label: "Layout",
  },
  {
    id: "ZfO3nhrBLCS2aNhTcO5p",
    label: "Resale Land",
  },
  {
    id: "xOl7nFLzvXtqVAcSrvIC",
    label: "Apartment",
  },
  {
    id: "sczwuE4dZNBGlJOfa3wd",
    label: "Resale Building",
  },
  {
    id: "k6QfCzo0QVXutC3MUTfV",
    label: "Villa",
  },
];

export const propertySaleTypes = [
  {
    id: "nezUZrknJG9DGcaQj12i",
    label: "Sale",
  },
  {
    id: "Guzl7JgCKM4tpXJS7K00",
    label: "Resale",
  },
  {
    id: "NIUMu3gATZSSbLusuvwb",
    label: "Rent",
  },
];

export const  roadFacingSides = [
  {
    id: "a2m4XDgDaZZn3uvUABck",
    label: "North",
  },
  {
    id: "ugWwkRDLnFxXeljNhvSV",
    label: "East",
  },
  {
    id: "mOpN3AmEklu2qQchUBQB",
    label: "West",
  },
  {
    id: "3Y3uSzg0325cRTfz48uP",
    label: "South",
  },
  {
    id: "79JJUWuqiIfUiYS3rlwi",
    label: "North East",
  },
  {
    id: "79h4vdWhTiTmfniibAiT",
    label: "North West",
  },
  {
    id: "SYbehSIIvbKnPkH5LVcf",
    label: "South East",
  },
  {
    id: "y9w3SwDxD9zJLEXRlnAR",
    label: "South West",
  },
];

export const underOfGovernances = [
  { label: "Municipal", value: "Municipal" },
  { label: "Panchayat", value: "Panchayat" },
  { label: "Corporation", value: "Corporation" },
];

export const plotStatusIds = [
  {
    id: "aufs9LEstTH1jkd1lcjD",
    label: "Available",
  },
  {
    id: "bnI2du7WXXbTvnx3dz1t",
    label: "Booked",
  },
  {
    id: "N6ybBNpbaYg8sOl5iZfj",
    label: "Agreement",
  },
  {
    id: "ylDevuPUDBzdGXM44j1P",
    label: "Registered",
  },
];

export const constructionType = [
  {
    label: "Under Construction",
    value: "Under Construction",
  },
  {
    label: "Ready to Move",
    value: "Ready to Move",
  },
  {
    label: "Customized Construction",
    value: "Customized Construction",
  },
];
// export const villaViewType = [
//   {
//     id: "VfdXXEqlvt0iHOWpk0mP",
//     label: "Sea View",
//   },
//   {
//     id: "IPBrRZBj3vIU0prDWuOI",
//     label: "Lake View",
//   },
//   {
//     id: "HMclw2eFvrJpwsBhYbH5",
//     label: "Mountain View",
//   },
//   {
//     id: "wPxaDy2Ipg5JbXSPty3Y",
//     label: "City View",
//   },
//   {
//     id: "Cnc0OgYd9W33ngzpewMD",
//     label: "Garden View",
//   },
// ];

//  Start {villa property Units }

export const furnishedList = [
  {
    value: "Furnished",
    label: "Furnished",
    
  },
  {
    value: "Semi Furnished",
    label: "Semi Furnished",
  
  },
  {
    value: "Unfurnished",
    label: "Unfurnished"
  },
]

export const parkingType = [
  {
    label: "Vertical Parking",
    value: "Vertical Parking",
  },
  {
    label: "Horizontal Parking",
    value: "Horizontal Parking",
  },
  {
    label: "Reserved Private Parking",
    value: "Reserved Private Parking",
  },
  {
    label: "Shared Parking",
    value: "Shared Parking",
  },
  {
    label: "Street Parking",
    value: "Street Parking",
  },
  {
    label: "None",
    value: "None",
  },
];



export const coveredParkingType = [
{
  label: "Fully Covered Parking",
  value: "Fully Covered Parking",
},{
  label: "Semi Covered Parking",
  value: "Semi Covered Parking",
},{
  label: "None",
  value: "None",
}
]



export const liftType = [
{
  label: "2-3 Member (upto 500 lb)",
  value: "2-3 Member (upto 500 lb)",
},{
  label: "4-6 Member (upto 800 lb)",
  value: "4-6 Member (upto 800 lb)",
},{
  label: "above 6 Member (upto 2000 lb)",
  value: "above 6 Member (upto 2000 lb)",
},{
  label: "None",
  value: "None",
}
]

export const swimmingPoolType = [
  {
    label: "Adult Swimming Pool",
    value: "Adult Swimming Pool",
  },
  {
    label: "Kids & Adult Swimming Pool",
    value: "Kids & Adult Swimming Pool",
  },
  {
    label: "Jacuzzi Swimming Pool",
    value: "Jacuzzi Swimming Pool",
  },
  {
    label: "Hot Tub/Spa Swimming Pool",
    value: "Hot Tub/Spa Swimming Pool",
  },
  {
    label: "None",
    value: "None",
  },
]

export const villaViewType = [
  {
    label: "Sea View",
    value: "Sea View",
  }
  ,
  {
    label: "Mountain View",
    value: "Mountain View",
  }
  ,
  {
    label: "City View",
    value: "City View",
  }
  ,
  {
    label: "Garden View",
    value: "Garden View",
  }
  ,
  {
    label: "None",
    value: "None",
  }
]

// end {villa property Units }

// Start  Apartment property units


export const balconyDirection = [
  {
    label: "North",
    value: "North",

  },{
    label: "North-East",
    value: "North-East",
  },{
    label: "East",
    value: "East",
  },{
    label: "South-East",
    value: "South-East",
  },{
    label: "South",
    value: "South",
  },{
    label: "South-West",
    value: "South-West",
  },{
    label: "West",
    value: "West",
  },{
    label: "North-West",
    value: "North-West",
  }
]



export const balconyView = [
  {
    label: "City View",
    value: "City View",

  },{
    label: "Garden / Park View",
    value: "Garden / Park View",
  },{
    label: "Sea / Lake / River View",
    value: "Sea / Lake / River View",
  },{
    label: "Mountain / Hill View",
    value: "Mountain / Hill View",
  },{
    label: "Swimming Pool View",
    value: "Swimming Pool View",
  },{
    label: "Clubhouse / Amenity View",
    value: "Clubhouse / Amenity View",
  },{
    label: "Road View / Street View",
    value: "Road View / Street View",
  },{
    label: "Faces internal amenities like clubhouse, tennis courts, kids’ play area.",
    value: "Faces internal amenities like clubhouse, tennis courts, kids’ play area.",
  },{
    label: "Faces a wall or very close neighboring build",
    value: "Faces a wall or very close neighboring build",
  }
]

// End {Apartment property units}

const dealStagesData = {
  "Site Visit": "naH0Hq5WlwVjlu66SyoF",
  "After Site Visit Follow Up": "hdt7EgiEiZeLXJkAbJQw",
  Sitting: "gPgKIfVobOoO8plDjaL1",
  "After Sitting Follow Up": "tzT2qiCM1ZJoppfd6l2A",
  "Plot Booked": "Q9JZE1p3V8dahjH8eMwl",
  "Advance Amount Update": "XkjJnPForSV0VRK81Pyq",
  "Registration InProgress": "lu8FY04HlUM7wtuLG3wd",
  "Fully Registered": "OeC8MZqNykSosVgiPIGx",
  "Deal Lost Before Booking": "eg6Sa6oxnxCr6ZBz4myj",
  "Deal Lost After Booking": "f8ddj5YskQd26cPDcqZM",
};

const leadStatusMap = {
  Fresh: "L0CTrn0qwWlHWvq2gXDm",
  "Deal Lost": "8337Bve50LqwfrkveUrY",
  "Follow-up": "Auf9SQFhiKF7WRM9ZiTA",
  "Retry Suitable": "PdCEXW0VIoVviuqvjdWc",
  "Not Interested": "VH26wB3VgVXBzoBJiqml",
  Dealing: "gJxbL16EjFbzDFCoQU5G",
  Unanswered: "yUuWlPRZEosdOeLzyL0f",
  "Registered Client": "znvixWClH1PDoCXO4Aat",

  //   "L0CTrn0qwWlHWvq2gXDm": StringConstants.freshLeadStatusText,
  //   // "Fresh",
  //   "Auf9SQFhiKF7WRM9ZiTA": StringConstants.followUpLeadStatusText,
  //   "gJxbL16EjFbzDFCoQU5G": StringConstants.dealingLeadStatusText,
  //   "znvixWClH1PDoCXO4Aat": StringConstants.customerLeadStatusText,
  //   "8337Bve50LqwfrkveUrY": StringConstants.dealLostLeadStatusText,
  //   "yUuWlPRZEosdOeLzyL0f": StringConstants.unansweredLeadStatusText,
  //   "VH26wB3VgVXBzoBJiqml": StringConstants.notInterestedLeadStatusText,
  //   "PdCEXW0VIoVviuqvjdWc": StringConstants.retrySuitableLeadStatusText
};

const bookingPaymentType = {
  h1XYmDM384DMp9V9TjoB: "Cash",
  v4s08PWNt0bJRYMzpap0: "Loan",
  LCIHTCEmTrkKq2qB1yYq: "DD",
  "9rJ39FBvmhkEYvEGpK6L": "OCR-NEFT",
  bdhSiAxe2sLizWGDabhp: "OCR-RTGS",
  "2onjCf7kV9syVVulJP1g": "OCR-IMPS",
  kb9eiMJqQy2dxa7Fg7v8: "Cheque",
  RjI0CAOzeyOBzRqWiKPg: "UPI Transaction",
};

const paymentType = {
  rAXrohvDd9juMPVykndB: "Loan",
  TuIwHf9x3EmswiH6uy1H: "Cash",
};

const interestLevel = [
  {
    value: "YkC7pUhxKKURN7AZjDhl",
    label: "Diamond",
    image: getIcons().diamond,
  },
  {
    value: "80OWCT8bC9H25c4lt83r",
    label: "Gold",
    image: getIcons().gold,
  },

  {
    value: "lIOauRSITzlqtQ3WwctM",
    label: "Silver",
    image: getIcons().silver,
  },
  {
    value: "N3ZumYbY3xL2II1Pajco",
    label: "Bronze",
    image: getIcons().bronze,
  },
];

const statusIcons = Object.freeze([
  {
    label: "Fresh",
    image: getIcons().freshIcon,
  },
  {
    label: "Registered Client",
    image: getIcons().registeredClient,
  },
  {
    label: "Follow-up",
    image: getIcons().interestedIcon,
  },
  {
    label: "Deal Lost",
    image: getIcons().dealLostIcon,
  },
  {
    label: "Not Interested",
    image: getIcons().notInterestedIcon,
  },
  {
    label: "Unanswered",
    image: getIcons().unansweredIcon,
  },
  {
    label: "Retry Suitable",
    image: getIcons().RetrySuitable,
  },
  {
    label: "Dealing",
    image: getIcons().dealingIcon,
  },
  {
    label: "Junk",
    image : getIcons().Junk
  }
]);

const getStatusBgColor = (label) => {
  switch (label) {
    case "Fresh":
      return "bg-[#74F2C433] border-2 border-[#399E79]";
    case "Registered Client":
      return "bg-[#2280FF1A] border-2 border-[#2280FF]";
    case "Follow-up":
      return "bg-[#D2FAEC80] border-2 border-[#399E79]";
    case "Deal Lost":
      return "bg-[#FDB1B140] border-2 border-[#FDB1B1]";
    case "Not Interested":
      return "bg-[#FFBFA44D] border-2 border-[#FFBFA4]";
    case "Unanswered":
      return "bg-[#FFBFA44D] border-2 border-[#FFBFA4]";
    case "Retry Suitable":
      return "bg-[#74F2C433] border-2 border-[#399E79]";
    default:
      return "bg-[#74F2C433] border-2 border-[#399E79]";
  }
};

const dataLimitation = {
  interestTag: 250,
  leadSource: 250,
  locationTag: 250,
};

export {
  listOfPropertyType,
  dataLimitation,
  dealStagesData,
  getStatusBgColor,
  statusIcons,
  bookingPaymentType,
  paymentType,
  leadStatusMap,
  interestLevel,
};

export function formatIndianCurrency(amount) {
  amount = amount.toString().replace(/[^0-9.]/g, "");

  const roundedAmount = Math.round(amount); 
  return roundedAmount.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0, 
  });
}

export function numberToWords(num) {

  num = num.toString().replace(/[^0-9.]/g, "");
  if (num === 0) return "Zero Rupees";

  const ones = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen",
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
  ];

  function convertToWords(n) {
    if (n < 20) return ones[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "");
    if (n < 1000)
      return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " and " + convertToWords(n % 100) : "");
    return "";
  }

  let result = "";
  let crore = Math.floor(num / 10000000);
  let lakh = Math.floor((num % 10000000) / 100000);
  let thousand = Math.floor((num % 100000) / 1000);
  let hundred = Math.floor((num % 1000) / 100);
  let remainder = num % 100;

  if (crore) result += convertToWords(crore) + " Crore ";
  if (lakh) result += convertToWords(lakh) + " Lakh ";
  if (thousand) result += convertToWords(thousand) + " Thousand ";
  if (hundred) result += convertToWords(hundred) + " Hundred ";
  if (remainder) result += (hundred ? "and " : "") + convertToWords(remainder);

  return result.trim() + " Rupees Only";
}